import React from "react";

export default class ContactMap extends React.Component {

    iframe_src = '';

    constructor(props) {
        super(props);
        this.iframe_src = props.fieldData.detail;
    }

    render() {
        return (
            <div className="map-wrapper">
                <iframe title="contact-map"
                    src={this.iframe_src}

                    loading="lazy"
                ></iframe>
            </div>
        );
    }
}

